import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { preCheckObjectEmpty } from "../../Modal/ModalArchive";
import { getAccountType } from "../types";
import ModalHolder from "../../Modal/ModalHolder";
import HoldersForm from "../HoldersForm";
import ModalConfirm from "../../Modal/ModalConfirm";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";
import ModalError from "../../Modal/ModalError";

const HoldersTab = ({
  holders,
  account,
  accountId,
  setAccountData,
  disabledFields,
  services,
  userType,
  isReadOnly,
  mode,
  Link,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [collapsedHolder, setCollapsedHolder] = useState([]);
  const [changedHolder, setChangedHolder] = useState({});
  const [modalHolder, setModalHolder] = useState({
    open: false,
    saving: false,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
    holderId: undefined,
  });
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  useEffect(() => {
    if (holders) {
      const newCollapsedHolder = holders.map(() => ({
        open: false,
        canEdit: false,
      }));
      setCollapsedHolder(newCollapsedHolder);
    }
  }, [holders]);

  const toggleModalHolder = () =>
    setModalHolder((m) => ({
      open: !m.open,
      saving: false,
    }));

  const toggleModalError = (e, message) =>
    setModalError({
      open: !modalError.open,
      message,
    });

  const handleDeleteHolder = (holderId) => {
    let canDelete = true;
    const allHolders = [...holders];

    // allHolders.forEach((holder) => {
    //   if (
    //     !account.AccountIsPhysical &&
    //     holder.AccountHolderId === holderId &&
    //     holder.AccountHolderRelationshipJuridical == "Holder"
    //   ) {
    //     canDelete = false;
    //   }
    // });

    if (canDelete) {
      const postAccount = {
        AccountId: accountId,
        AccountOnboardingId: accountId,
        Holder: [
          {
            PersonId: holderId,
            deleteHolder: true,
          },
        ],
      };
      const body = {
        account: postAccount,
        accountChangeType: getAccountType.Holders,
      };
      setModalConfirm((m) => ({
        ...m,
        loading: true,
      }));
      if (mode !== AccountMode.New) {
        services.fetchAccountUpdate(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            let index = -1;
            allHolders.forEach((holder, i) => {
              if (parseInt(holderId, 10) === parseInt(holder.AccountHolderId, 10)) {
                index = i;
              }
            });
            if (index > -1) {
              allHolders.splice(index, 1);
              collapsedHolder.splice(index, 1);
            }
            setModalConfirm({
              open: false,
              title: "",
              holderId: undefined,
              callback: undefined,
              loading: false,
            });
            setAccountData(
              {
                AccountId: accountId,
                AccountInfoHolder: allHolders,
              },
              true
            );
          } else {
            setModalConfirm((m) => ({
              ...m,
              loading: false,
            }));
          }
        });
      } else {
        services.fetchNewAccount(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            let index = -1;
            allHolders.forEach((holder, i) => {
              if (parseInt(holderId, 10) === parseInt(holder.AccountHolderId, 10)) {
                index = i;
              }
            });
            if (index > -1) {
              allHolders.splice(index, 1);
              collapsedHolder.splice(index, 1);
            }
            setModalConfirm({
              open: false,
              title: "",
              holderId: undefined,
              callback: undefined,
              loading: false,
            });
            setAccountData(
              {
                AccountId: accountId,
                AccountInfoHolder: allHolders,
              },
              true
            );
          } else {
            setModalConfirm((m) => ({
              ...m,
              loading: false,
            }));
          }
        });
      }
    } else {
      toggleModalError({}, "Error. The Main Holder can not be deleted.");
    }
  };

  // useEffect(() => {
  //   if (mode === AccountMode.New){
  //     if (holders && holders.length < 1) {
  //       const body = {
  //         AccountGetInfo: {
  //           GetAccountDataId: accountId,
  //           GetAccountDataOnboardingId: accountId,
  //           GetAccountDataType: getAccountType.Holders,
  //         },
  //       };
  //       services.fetchNewAccountInfo(body, (data) => {
  //         if (data && data.SDTAccount) {
  //           setAccountData({
  //             AccountId: accountId,
  //             AccountArchives: data.SDTAccount.AccountInfoHolder,
  //           }, false);
  //         }
  //       });
  //     }

  //   }
  // }, []);

  const handleRemoveHolder = (holderId) =>
    setModalConfirm((m) => ({
      ...m,
      open: true,
      title: "Are you sure you want to remove the selected Holder?",
      holderId,
      callback: () => handleDeleteHolder(holderId),
    }));

  const toggleModalConfirm = () =>
    setModalConfirm({
      open: false,
      title: "",
      holderId: undefined,
      callback: undefined,
      loading: false,
    });

  const revert = () => setChangedHolder({});

  const handleSave = (newHolders) => {
    let hasMainHolder = false;
    let addHolder = true;
    let errorMessage = "Error. The account already has a Main Holder.";

    const allHolders = [...holders];
    allHolders.forEach((holder) => {
      if (
        holder.IsMainHolder ||
        (holder.HoldersRelationship == "Holder" && holder.HoldersRelationshipJuridical == "Holder")
      ) {
        hasMainHolder = true;
      }
    });

    let oldMainHolderRemoved = false;
    let newMainHolderAdded = false;
    const newAccountHolders = Object.keys(newHolders).map((key) => newHolders[key]);
    newAccountHolders.forEach((newHolder) => {
      const existHolder = holders.find(
        (currentHolder) => currentHolder.AccountHolderId == newHolder.AccountHolderId
      );

      if (existHolder != null) {
        if (existHolder.IsMainHolder && !newHolder.isMainHolder) {
          // saco el main holder
          oldMainHolderRemoved = true;
        }
      }

      if (newHolder.isMainHolder) {
        // Es main
        newMainHolderAdded = true;
      }

      const isValidEdit = existHolder != null && existHolder.IsMainHolder == newHolder.isMainHolder;

      if (
        !account.AccountIsPhysical &&
        hasMainHolder &&
        newHolder.HoldersRelationshipJuridical == "Holder" &&
        !isValidEdit
      ) {
        addHolder = false;
      } else {
        if (
          !isValidEdit &&
          account.AccountInfoHolder.find(
            (accountHolders) =>
              accountHolders.AccountHolderId === newHolder.AccountHolderId &&
              accountHolders.AccountHolderRelationshipJuridical == "Holder"
          )
        ) {
          addHolder = false;
          errorMessage = "Error. The account needs to have a Main Holder.";
        }
      }
    });

    if (oldMainHolderRemoved && !newMainHolderAdded) {
      const response = window.confirm(
        "There is no Main Holder in the Account.\nThis will change the Account type to juridical.\nAre you sure to proceed?"
      );
      if (!response) {
        return;
      }
    }

    if (addHolder) {
      if (!account.AccountIsPhysical) {
        const mainHolderRef = newAccountHolders[0];
        mainHolderRef.isMainHolder = mainHolderRef.HoldersRelationshipJuridical == "Holder";
      }

      const postAccount = {
        AccountId: accountId,
        AccountOnboardingId: accountId,
        AccountIsPhysical: account.AccountIsPhysical,
        Holder: newAccountHolders,
      };
      const body = {
        account: postAccount,
        accountChangeType: getAccountType.Holders,
      };
      setLoadingSave(true);
      if (mode !== AccountMode.New) {
        services.fetchAccountUpdate(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            Object.keys(newHolders).forEach((key) => {
              let index = -1;
              const newHolder = {
                AccountHolderId: newHolders[key].PersonId,
                AccountHolderName: newHolders[key].PersonName,
                AccountHolderPersonType: newHolders[key].PersonType,
                AccountHolderRelationship: newHolders[key].HoldersRelationship,
                AccountHolderRelationshipDescription: newHolders[key].HoldersRelationshipDescription,
                AccountHolderRelationshipJuridical: newHolders[key].HoldersRelationshipJuridical,
                AccountHolderIsController: newHolders[key].HoldersIsController,
                AccountHolderIsManager: newHolders[key].HoldersIsManager,
                IsMainHolder: newHolders[key].isMainHolder,
                HoldersOrderWeb: newHolders[key].HoldersOrderWeb,
                HoldersOrderManaged: newHolders[key].HoldersOrderManaged,
                HoldersOrderWritten: newHolders[key].HoldersOrderWritten,
                HoldersOrderViaLink: newHolders[key].HoldersOrderViaLink,
                AccountHolderIsBeneficiary: newHolders[key].AccountHolderIsBeneficiary,
                AccountHolderEmail: response.newHolderInfo.AccountHolderEmail,
                AccountHolderAddress: response.newHolderInfo.AccountHolderAddress,
                AccountHolderCountryId: response.newHolderInfo.AccountHolderCountryId,
                AccountHolderCountryName: response.newHolderInfo.AccountHolderCountryName,
                AccountHolderByAdvisor: userType == "Advisor",
              };
              allHolders.forEach((holder, i) => {
                if (parseInt(newHolder.AccountHolderId, 10) === parseInt(holder.AccountHolderId, 10)) {
                  index = i;
                }
              });
              if (index > -1) {
                allHolders[index] = {
                  ...allHolders[index],
                  ...newHolder,
                };
                collapsedHolder[index].canEdit = false;
              } else {
                holders.push(newHolder);
                collapsedHolder.push({ open: false, canEdit: false });
              }
            });
            setLoadingSave(false);
            setChangedHolder({});
            setAccountData(
              {
                AccountId: accountId,
                AccountInfoHolder: allHolders,
              },
              true
            );
          } else {
            setLoadingSave(false);
          }
        });
      } else {
        services.fetchNewAccount(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            Object.keys(newHolders).forEach((key) => {
              let index = -1;
              const newHolder = {
                AccountHolderId: newHolders[key].PersonId,
                AccountHolderName: newHolders[key].PersonName,
                AccountHolderPersonType: newHolders[key].PersonType,
                AccountHolderStatus: newHolders[key].PersonStatus,
                AccountHolderRelationship: newHolders[key].HoldersRelationship,
                AccountHolderRelationshipJuridical: newHolders[key].HoldersRelationshipJuridical,
                AccountHolderRelationshipDescription: newHolders[key].HoldersRelationshipDescription,
                AccountHolderIsController: newHolders[key].HoldersIsController,
                AccountHolderIsManager: newHolders[key].HoldersIsManager,
                IsMainHolder: newHolders[key].isMainHolder,
                HoldersOrderWeb: newHolders[key].HoldersOrderWeb,
                HoldersOrderManaged: newHolders[key].HoldersOrderManaged,
                HoldersOrderWritten: newHolders[key].HoldersOrderWritten,
                HoldersOrderViaLink: newHolders[key].HoldersOrderViaLink,
                AccountHolderIsBeneficiary: newHolders[key].AccountHolderIsBeneficiary,
                AccountHolderEmail: response.newHolderInfo.AccountHolderEmail,
                AccountHolderAddress: response.newHolderInfo.AccountHolderAddress,
                AccountHolderCountryId: response.newHolderInfo.AccountHolderCountryId,
                AccountHolderCountryName: response.newHolderInfo.AccountHolderCountryName,
                AccountHolderByAdvisor: userType == "Advisor",
                AccountHolderTel: response.newHolderInfo.AccountHolderTel,
                AccountHolderDocumentTypeName: response.newHolderInfo.AccountHolderDocumentTypeName,
                AccountHolderDocumentNumber: response.newHolderInfo.AccountHolderDocumentNumber,
              };
              allHolders.forEach((holder, i) => {
                if (parseInt(newHolder.AccountHolderId, 10) === parseInt(holder.AccountHolderId, 10)) {
                  index = i;
                }
              });
              if (index > -1) {
                allHolders[index] = {
                  ...allHolders[index],
                  ...newHolder,
                };
                collapsedHolder[index].canEdit = false;
              } else {
                holders.push(newHolder);
                allHolders.push(newHolder);
                collapsedHolder.push({ open: false, canEdit: false });
              }
            });
            setLoadingSave(false);
            setChangedHolder({});
            setAccountData(
              {
                AccountId: accountId,
                AccountInfoHolder: allHolders,
              },
              true
            );
          } else {
            setLoadingSave(false);
          }
        });
      }
    } else {
      toggleModalError({}, errorMessage);
    }
  };

  const toggleHolder = (index, toggle) => {
    const newCollapsedHolder = [...collapsedHolder];
    if (toggle) {
      for (let i = 0; i < newCollapsedHolder.length; i += 1) {
        if (i === index) {
          newCollapsedHolder[i] = {
            open: !newCollapsedHolder[i].open,
            canEdit: false,
          };
        } else {
          newCollapsedHolder[i] = {
            open: false,
            canEdit: false,
          };
        }
      }
    } else {
      newCollapsedHolder[index].canEdit = !newCollapsedHolder[index].canEdit;
    }
    setCollapsedHolder(newCollapsedHolder);
  };

  const onChange = (index, name, value) => {
    const newChangedHolder = { ...changedHolder };
    if (!newChangedHolder[holders[index].AccountHolderId]) {
      newChangedHolder[holders[index].AccountHolderId] = {
        HoldersRelationshipDescription: holders[index].AccountHolderRelationshipDescription,
        PersonId: holders[index].AccountHolderId,
        PersonName: holders[index].AccountHolderName,
        PersonType: holders[index].AccountHolderPersonType,
        PersonStatus: holders[index].AccountHolderStatus,
        AccountHolderId: holders[index].AccountHolderId,
        HoldersRelationship: holders[index].AccountHolderRelationship,
        HoldersRelationshipJuridical: holders[index].AccountHolderRelationshipJuridical,
        HoldersIsController: holders[index].AccountHolderIsController,
        HoldersIsManager: holders[index].AccountHolderIsManager,
        isMainHolder: holders[index].IsMainHolder,
        deleteHolder: false,
        HoldersOrderWeb: holders[index].HoldersOrderWeb,
        HoldersOrderWritten: holders[index].HoldersOrderWritten,
        HoldersOrderManaged: holders[index].HoldersOrderManaged,
        HoldersOrderViaLink: holders[index].HoldersOrderViaLink,
        [name]: value,
      };
    } else {
      newChangedHolder[holders[index].AccountHolderId][name] = value;
    }
    if (name === "HoldersOrderManaged" && value) {
      newChangedHolder[holders[index].AccountHolderId].HoldersOrderViaLink = false;
      newChangedHolder[holders[index].AccountHolderId].HoldersOrderWeb = false;
      newChangedHolder[holders[index].AccountHolderId].HoldersOrderWritten = false;
    }
    if (name === "HoldersOrderWritten" && value) {
      newChangedHolder[holders[index].AccountHolderId].HoldersOrderManaged = false;
    }
    if (name === "HoldersRelationshipJuridical" && value) {
      if (value === "Holder") {
        newChangedHolder[holders[index].AccountHolderId].isMainHolder = true;
      } else {
        newChangedHolder[holders[index].AccountHolderId].isMainHolder = false;
      }
    }
    setChangedHolder(() => newChangedHolder);
  };

  if (!holders || collapsedHolder.length !== holders.length) {
    return <CircularProgress sm />;
  }

  let existsMainHolder = false;
  holders.forEach((h) => {
    const isMainHolder = changedHolder[h.AccountHolderId]
      ? changedHolder[h.AccountHolderId].isMainHolder
      : h.IsMainHolder;
    existsMainHolder = existsMainHolder || isMainHolder;
  });

  return (
    <div>
      <HoldersForm
        holders={
          account.AccountMode !== mode.New
            ? account.AccountIsPhysical
              ? holders.filter(
                  (holder) =>
                    (holder.AccountHolderRelationship == "Holder" ||
                      holder.AccountHolderRelationship == "Attorney" ||
                      holder.AccountHolderRelationship == "Authorized" ||
                      holder.AccountHolderRelationship == "Other" ||
                      holder.AccountHolderRelationship == "WebAuthorized") &&
                    !holder.AccountHolderByAdvisor &&
                    !holder.AccountHolderIsBeneficiary
                )
              : holders.filter(
                  (holder) =>
                    holder.AccountHolderRelationshipJuridical == "Holder" ||
                    holder.AccountHolderRelationshipJuridical == "Attorney" ||
                    holder.AccountHolderRelationshipJuridical == "Representative" ||
                    holder.AccountHolderRelationshipJuridical == "WebAuthorized" ||
                    holder.AccountHolderRelationshipJuridical == "None" ||
                    holder.AccountHolderIsController === true ||
                    holder.AccountHolderIsManager === true
                )
            : holders
        }
        changedHolder={changedHolder}
        collapsedHolder={collapsedHolder}
        onChange={onChange}
        toggleHolder={toggleHolder}
        disabledFields={disabledFields}
        account={account}
        existsMainHolder={existsMainHolder}
        handleDeleteHolder={handleRemoveHolder}
        isReadOnly={isReadOnly}
        role={"Holder"}
        mode={mode}
        Link={Link}
      />
      {!isReadOnly && (
        <Button
          disabled={loadingSave}
          color="primary"
          style={{ marginRight: 10 }}
          onClick={toggleModalHolder}
        >
          Add New Holder
        </Button>
      )}
      {!isReadOnly && (
        <Button style={{ marginRight: 10 }} disabled={loadingSave} onClick={() => revert()}>
          <i className="fa fa-undo" /> Revert
        </Button>
      )}
      {!isReadOnly && (
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loadingSave}
          disabled={!preCheckObjectEmpty(changedHolder)}
          onClick={() => handleSave(changedHolder)}
          data-style={EXPAND_RIGHT}
        >
          Save
        </LaddaButton>
      )}
      <ModalHolder
        {...modalHolder}
        toggle={toggleModalHolder}
        onSave={handleSave}
        account={account}
        saving={loadingSave}
        holders={holders}
        services={services}
        Link={Link}
        role="Holder"
      />
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        title={modalConfirm.title}
        callback={modalConfirm.callback}
        saving={modalConfirm.loading}
      />
      <ModalError {...modalError} onToggle={toggleModalError} />
    </div>
  );
};

HoldersTab.propTypes = {
  holders: PropTypes.array.isRequired,
  accountId: PropTypes.any.isRequired,
  account: PropTypes.object.isRequired,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
};

export default HoldersTab;
